export default "__VITE_ASSET__285671f3__"